import { z } from "zod";

const choice = z.enum(["none", "direct_manager", "cost_center_owner"]);

export const approvalMatrixSchema = z
  .object({
    assetClaim: choice.default("cost_center_owner"),
    assetBorrow: choice.default("cost_center_owner"),
    accessoryApply: choice.default("direct_manager"),
    consumableIssue: choice.default("none"),
    softwareLow: choice.default("none"),
    softwareMid: choice.default("direct_manager"),
    softwareHigh: choice.default("cost_center_owner"),
    softwareMidThresholdCents: z.coerce.number().int().min(0).max(100_000_000).default(10_000),
    softwareHighThresholdCents: z.coerce.number().int().min(1).max(100_000_000).default(100_000),
  })
  .refine((value) => value.softwareHighThresholdCents > value.softwareMidThresholdCents, {
    message: "高额阈值必须大于中额阈值",
    path: ["softwareHighThresholdCents"],
  });

export type ApprovalMatrixInput = z.infer<typeof approvalMatrixSchema>;
